import React, { Component } from "react";
import JobTrackIframeEmbed from "components/common/JobTrackIframeEmbed";
import queryString from "query-string";
import StorageGateway from "lib/storage-gateway";

class IframeWagesAndCost extends Component {
  render() {
    const queryParams = queryString.parse(window.location.search);
    const empId = queryParams.empId || this.props.empId;
    const empName = queryParams.empName || this.props.empName;
    const empWage = queryParams.empWage || this.props.empWage;
    const refreshWagesAndCostKey = this.props.refreshWagesAndCostKey || Date.now();
    const JobTrackAuthToken = StorageGateway.get("JobTrackBearerToken");
    const JobTrackRefreshToken = StorageGateway.get("jobTrackRefreshToken");

    const orgId = StorageGateway.get("jobTrackOrgId");
    const jwtToken = StorageGateway.get("iframe_jwt_token");
    return (
      <div
        style={{
          height: "calc(90vh - 102px - 80px)",
          marginRight: "-15px",
        }}
      >
        {"   "}
        <JobTrackIframeEmbed
          key={refreshWagesAndCostKey} // Forces re-render when changed
          src={`${process.env.REACT_APP_JOBTRAKS_BASE_URL
            }screen/126/360%20view?access_token=${JobTrackAuthToken}&refresh_token=${JobTrackRefreshToken}&orgId=${orgId}&Cost%20Group=${encodeURIComponent(
              `{"employee":"${empId}","wage":"${empWage}","employee_name":"${empName}"}`
            )}&Associated%20Cost%20Items=${encodeURIComponent(
              `{"employee":"${empId}","wage":"${empWage}","employee_name":"${empName}"}`
            )}&Wages%20%26%20Cost=${encodeURIComponent(
              `{"employee":"${empId}","wage":"${empWage}","employee_name":"${empName}"}`
            )}&Budget=${encodeURIComponent(
              `{"employee":"${empId}"}`
            )}&embed=true`}
          type="tab"
        />
      </div>
    );
  }
}

export default IframeWagesAndCost;
